import { FilterRangeSlider as FilterRangeTrack } from '@vs-shop/commerce-ui/filterRange';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../utils/intl';

type Props = {
  min: number;
  max: number;
  step: number;
  minValue: number;
  maxValue: number;
  onValueChange: (value: readonly [number, number]) => void;
};

/**
 * The range track, in rcprofi's terms: the shared part plus the names its two
 * thumbs carry, which are copy and therefore the tenant's.
 */
export default function FilterRangeSlider({
  min,
  max,
  step,
  minValue,
  maxValue,
  onValueChange,
}: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <FilterRangeTrack
      min={min}
      max={max}
      step={step}
      value={[minValue, maxValue]}
      onValueChange={onValueChange}
      minLabel={intl.formatMessage({
        id: 'component.server.page.category.filter.categoryFilterRangeSlider.minimum',
        defaultMessage: 'Minimum',
      })}
      maxLabel={intl.formatMessage({
        id: 'component.server.page.category.filter.categoryFilterRangeSlider.maximum',
        defaultMessage: 'Maximum',
      })}
    />
  );
}
